export default __webpack_public_path__ + "939bf38b7345e8e625c2829e7c61e3cb.png";